export const yearList = [
  { label: "First Year", value: "1" },
  { label: "Second Year", value: "2" },
  { label: "Third Year", value: "3" },
  { label: "Final Year", value: "4" },
  { label: "Passed Out", value: "passed_out" },
];